<script setup lang="ts">
defineProps<{
    showLocalLogin?: boolean;
}>();
defineEmits(['login', 'oidcLogin']);
</script>
<template>
    <!-- dev login, username/pw + OIDC login -->
    <ktg-account-navigation v-if="showLocalLogin" :user-name="`${$t('login')} (DEV)`" icon-button-label="Account">
        <ktg-account-navigation-item icon="view-grid-filled" @item-click="$emit('login')">
            {{ $t('login') }} (DEV)
        </ktg-account-navigation-item>
        <ktg-account-navigation-item icon="view-grid-filled" @item-click="$emit('oidcLogin')">
            {{ $t('login') }} (OIDC)
        </ktg-account-navigation-item>
    </ktg-account-navigation>

    <!-- production login, only OIDC login -->
    <ktg-account-navigation
        v-else
        :button-label="`${$t('login')}`"
        icon-button-label="Account"
        @login="$emit('oidcLogin')"
    ></ktg-account-navigation>
</template>
